import React from 'react';
import { View } from 'react-native';

import { useDsEnabled } from '../contexts/DesignSystem';
import { cn } from '../utils/cn';
import ThemedText from './ThemedText';

interface InlineSuccessProps {
  message: string | null;
  testID?: string;
}

export const InlineSuccess: React.FC<InlineSuccessProps> = ({ message, testID }) => {
  const dsEnabled = useDsEnabled();

  if (!message) {
    return null;
  }

  return (
    <View
      className={
        dsEnabled
          ? 'mb-ds-16 rounded-ds-md bg-status-success-surface px-ds-16 py-ds-12'
          : 'bg-login-green-10 rounded-lg p-3 px-9 mt-2 mb-4'
      }
      testID={testID}
    >
      <ThemedText type='bodySmall' className={cn('text-center', !dsEnabled && 'text-login-green-90')}>
        {message}
      </ThemedText>
    </View>
  );
};
